import { combineReducers } from 'redux';
import {
  FETCH_BROKERS_REQUEST,
  FETCH_BROKERS_SUCCESS,
  FETCH_BROKERS_FAILURE,
  FETCH_BROKERS_LIST_REQUEST,
  FETCH_BROKERS_LIST_SUCCESS,
  FETCH_BROKERS_LIST_FAILURE,
  FETCH_BROKER_BY_ID_REQUEST,
  FETCH_BROKER_BY_ID_SUCCESS,
  FETCH_BROKER_BY_ID_FAILURE,
  BROKER_UPDATE_CONFIG,
  BROKER_STATUS_UPDATE,
  CLEAR_BROKER_BY_ID,
} from '../constants/ActionTypes';

const updateBrokerStatusUpdate = (state, action) => {
  let data = state.data && state.data.data ? state.data.data : [];
  const {
    broker = {},
    status = null,
    stoploss,
  } = action && action.data ? action.data : {};
  const { id: brokerId = '' } = broker;

  if (brokerId) {
    const findIndex = data.findIndex((b) => b.id === brokerId);

    if (findIndex >= 0) {
      data[findIndex].watchState.status = status;

      // if new stoploss update the stoploss
      if (stoploss || stoploss === 0) {
        data[findIndex].watchState.stoploss = stoploss;
      }
    }
  }

  return {
    data: {
      ...state.data,
      data: [...data],
    },
  };
};

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_BROKERS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_BROKERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_BROKERS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case BROKER_STATUS_UPDATE:
      // eslint-disable-next-line no-case-declarations
      const { data: dataBrokerStatusUpdate } = updateBrokerStatusUpdate(
        state,
        action
      );

      return {
        ...state,
        data: dataBrokerStatusUpdate,
      };
    default:
      return state;
  }
};

const dir = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_BROKERS_LIST_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_BROKERS_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_BROKERS_LIST_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_BROKER_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_BROKER_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data,
      };
    case FETCH_BROKER_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case BROKER_UPDATE_CONFIG:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data,
      };
    case CLEAR_BROKER_BY_ID:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: {},
      };
    default:
      return state;
  }
};

const brokers = combineReducers({
  list,
  selected,
  dir,
});

export default brokers;
